import makeService from './api';

export default makeService('hardness_shore_types');
